import Header from "../components/Header";
import Footer from "../components/Footer";
import UpperDashboard from "../components/UpperDashboard";

export default function Home() {
  return (
    <>
      <Header />
      <UpperDashboard />
      <Footer />
    </>
  );
}
